import { React, useState, useEffect } from "react";
import "./Declaration.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../AppContext";

function Declaration() {
  const navigate = useNavigate();

  const [source, setSource] = useState("");
  const [matData, setMatData] = useState([]);
  const [registrationMessage, setRegistrationMessage] = useState(null);

  const location = useLocation();
  const { email } = location.state || {};
  const { lastScannedBarcode: barcodeFromState } = location.state || {};
  //console.log(email);

  const { lastScannedBarcode: barcodeFromContext } = useAppContext();

  const lastScannedBarcode =
    barcodeFromState !== undefined && barcodeFromState !== null
      ? barcodeFromState
      : barcodeFromContext;

  //console.log(lastScannedBarcode);
  useEffect(() => {
    axios
      .get("https://nodei.ssccglpinnacle.com/getApproveDPO")
      .then((response) => {
        const latest30Data = response.data.map(
          ({ shipmentid, distributorName }) => ({
            shipmentid,
            distributorName,
          }),
        );
        setMatData(latest30Data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleSubmit = async () => {
    try {
      if (lastScannedBarcode.includes("-")) {
        const response = await axios.get(
          `https://auth.ssccglpinnacle.com/searchBarcode/${lastScannedBarcode}`,
        );
        const data1 = await response.data;
        if (data1 === "Not Found") {
          const secondResponse = await axios.post(
            "https://nodei.ssccglpinnacle.com/searchBarr",
            { searchValue: lastScannedBarcode },
          );
          const data2 = await secondResponse.data;
          if (
            data2.result === "Distributor" ||
            data2.result === "Pinnacle B2C" ||
            data2.result === "Pinnacle Warehouse" ||
            data2.result === "Flipkart B2C" ||
            data2.result === "Amazon B2C" ||
            data2.result === "Snapdeal B2C" ||
            data2.result === "Meesho B2C"
          ) {
            if (data2.result === "Distributor") {
              const shipmentid = data2.OrderNum;
              const distributor = matData.find(
                (item) => item.shipmentid === shipmentid,
              );
              if (distributor) {
                setSource(distributor.distributorName);
              }
            } else setSource(data2.result);
            setRegistrationMessage(
              `Verified - You have earned coin with respect to this book ${data2.result}`,
            );
            const updateResponse = await axios.put(
              `https://auth.ssccglpinnacle.com/updateStudentBooksAndCoins/${email}`,
              {
                searchBarcode: lastScannedBarcode,
                sku: "pinnacleBook",
              },
            );

            setRegistrationMessage(
              `Verified - You have earned coin with respect to this book ${data2.result}`,
            );

            navigate("/book-test-reward", {
              state: {
                email,
                barcode: lastScannedBarcode,
                source: data2.result,
              },
            });
            // Handle success response
            // console.log("Updated student:", updateResponse.data);
          } else {
            setRegistrationMessage("This Book not matched with our Database");
          }
        } else if (data1 === "Already Exist") {
          setRegistrationMessage(
            "This book has already been registered by another User.",
          );
        } else {
           console.log(data1);
        }
      } else {
        const response = await axios.get(
          `https://nodei.ssccglpinnacle.com/getKey/${lastScannedBarcode}`,
        );
        const key = response.data.key;

        const sku = response.data.sku;

        if (!key) {
          setRegistrationMessage("Key not found for given value");
          return;
        }
        const respons = await axios.get(
          `https://auth.ssccglpinnacle.com/searchBarcode/${lastScannedBarcode}`,
        );
        const data1 = await respons.data;

        if (data1 === "Not Found") {
          const secondResponse = await axios.post(
            "https://nodei.ssccglpinnacle.com/searchBarr",
            { searchValue: key },
          );
          const data2 = await secondResponse.data;

          if (
            data2.result === "Distributor" ||
            data2.result === "Pinnacle B2C" ||
            data2.result === "Pinnacle Warehouse" ||
            data2.result === "Flipkart B2C" ||
            data2.result === "Amazon B2C" ||
            data2.result === "Snapdeal B2C" ||
            data2.result === "Meesho B2C"
          ) {
            if (data2.result === "Distributor") {
              const shipmentid = data2.OrderNum;
              const distributor = matData.find(
                (item) => item.shipmentid === shipmentid,
              );
              if (distributor) {
                setSource(distributor.distributorName);
              }
            } else setSource(data2.result);
            setRegistrationMessage(
              `Verified - You have earned coin with respect to this book ${data2.result}`,
            );
            const updateResponse = await axios.put(
              `https://auth.ssccglpinnacle.com/updateStudentBooksAndCoins/${email}`,
              {
                searchBarcode: lastScannedBarcode,
                sku: sku, // Assuming 'key' is the SKU
              },
            );

            setRegistrationMessage(
              `Verified - You have earned coin with respect to this book ${data2.result}`,
            );

            navigate("/book-test-reward", {
              state: {
                email,
                barcode: lastScannedBarcode,
                source: data2.result,
              },
            });

            // Handle success response
            // console.log("Updated student:", updateResponse.data);
          } else {
            setRegistrationMessage("This Book not matched with our Database");
          }
        } else if (data1 === "Already Exist") {
          setRegistrationMessage(
            "This book has already been registered by another User.",
          );
        } else {
       console.log(data1);
        }
      }
    } catch (error) {
  if (
    error.response?.status === 409 &&
    error.response?.data?.error === "SAME_BOOK_ALREADY_REGISTERED"
  ) {
    setRegistrationMessage("You have already registered this book using a different barcode.");
    return;
  }

  console.error("Error fetching data:", error);

  setRegistrationMessage(
    error.response?.data?.message || "Something went wrong",
  );
}
  };

  return (
    <div className="Maindiv">
      <h5>Book Registration</h5>
      <p>
        I hereby declare that I have purchased below book having unique code on
        the book.you may take any action if I provided wrong information and
        claimed the book which was not purchased by me.{" "}
      </p>

      <div
        style={{
          margin: "20px auto",
          padding: "16px 20px",
          maxWidth: "650px",
          background: "linear-gradient(135deg, #fff8e1, #fff3cd)",
          border: "2px solid #f4c430",
          borderRadius: "14px",
          textAlign: "center",
          boxShadow: "0 0 12px rgba(255,193,7,0.45)",
          animation: "rewardGlow 1.5s ease-in-out infinite alternate",
        }}
      >
        <div
          style={{
            fontSize: "17px",
            fontWeight: "600",
            color: "#333",
            lineHeight: "1.6",
          }}
        >
          Submit your book registration to earn
          <span style={{ color: "#16a34a", fontWeight: "700" }}>
            {" "}
            50 Coins
          </span>{" "}
          and
          <span style={{ color: "#2563eb", fontWeight: "700" }}>
            {" "}
            5 FREE Mock Tests
          </span>{" "}
          after successful verification.
        </div>
      </div>
      <button type="submit" className="summit" onClick={handleSubmit}>
        Submit
      </button>
      {registrationMessage && <h3>{registrationMessage}</h3>}
      {source && <h2>Book Source : {source}</h2>}
    </div>
  );
}
export default Declaration;
